__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-10-1789046738-stable-dev/";